import {Injectable, NgZone} from '@angular/core';
import {AuthService} from "./auth.service";
import {NavController} from "@ionic/angular";
import {UserService} from "../customer/user.service";
import {App, URLOpenListenerEvent} from "@capacitor/app";
import {Router} from "@angular/router";
import {AuthStorageService} from "../storage/auth-storage.service";

@Injectable({
  providedIn: 'root'
})
export class PageNavigationService {

  constructor(
    private authService: AuthService,
    private navController: NavController,
    private userService: UserService,
    private zone: NgZone,
    private router: Router,
    private authStorage: AuthStorageService
  ) {
  }

  public init() {
    this.deepLink();
    this.authService.Login.subscribe(async () => this.redirectToStart());
    this.authService.Logout.subscribe(async () => this.redirectToSignIn());
  }

  private async redirectToSignIn() {
    const params = await this.authStorage.getSignInMode();
    return this.navController.navigateRoot('/signin' + (params ? '/' + params : ''));
  }

  private async redirectToStart() {
    if (!this.shouldRedirectToStart()) {
      return;
    }
    const isEmployee = await this.userService.hasRole();
    if (isEmployee) {
      return this.navController.navigateRoot('/admin');
    } else {
      return this.navController.navigateRoot('/product-category-list');
    }
  }

  deepLink() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        const slug = event.url.split('.net').pop();
        if (slug) {
          this.router.navigateByUrl(slug);
        }
      });
    });
  }

  private shouldRedirectToStart(): boolean {
    const currentPath = this.getCurrentPath();
    if (currentPath === '' || currentPath === '/' || currentPath === '/tabs') {
      return true;
    }
    if (currentPath.startsWith('/signin') || currentPath.startsWith('/signup')) {
      return true;
    }
    return false;
  }

  private getCurrentPath(): string {
    const routerUrl = this.normalizeUrl(this.router.url);
    if (routerUrl && routerUrl !== '/' && routerUrl !== '/tabs') {
      return routerUrl;
    }
    if (typeof window !== 'undefined' && window?.location?.pathname) {
      return this.normalizeUrl(window.location.pathname);
    }
    return routerUrl;
  }

  private normalizeUrl(url: string): string {
    return (url || '').split('#')[0].split('?')[0].toLowerCase();
  }
}
